// extracted by mini-css-extract-plugin
export default {"accessRightIndicator":"institutionMemberListPopup_accessRightIndicator__5ePmd"};